import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
    return (
        <div className="loading-screen">
            <div className="loading-logo">
            <span className="letter-l">@</span>
                <span className="letter-l">n</span>
                <span className="letter-e">u</span>
                <span className="letter-l">a</span>
                <span className="letter-l">l</span>
                <span className="letter-e">i</span>
                <span className="letter-l">l</span>
                <span className="letter-l">y</span>

             
            </div>
            <div className="marketplace">Boutique</div>
            <div className="loading-dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
            <p>Tu Tienda de Velas Artesanales</p>
            <p>Estamos en el Maresme</p>
        </div>
    );
};

export default LoadingScreen;
